// extracted by mini-css-extract-plugin
module.exports = {"post":"templates-module--post--1NQxD","origin":"templates-module--origin--14n8g","content":"templates-module--content--TR_1_","tag":"templates-module--tag--u1le1"};